import { render, staticRenderFns } from "./NewAutomation.vue?vue&type=template&id=2ad15178&scoped=true"
import script from "./NewAutomation.vue?vue&type=script&lang=js"
export * from "./NewAutomation.vue?vue&type=script&lang=js"
import style0 from "./NewAutomation.vue?vue&type=style&index=0&id=2ad15178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad15178",
  null
  
)

export default component.exports